import styled from 'styled-components'

import breakpoints from '../../constants/ui/breakpoints'

import { Section } from '../PageLayout'

export const GeofencingStyled = styled(Section)`
  .title {
    margin-bottom: 1.5rem;
    max-width: 800px;
  }

  .text {
    margin-bottom: 3rem;
    max-width: 780px;

    @media (max-width: ${breakpoints.screenMD}) {
      margin-bottom: 2.5rem;
      max-width: 100%;
    }
  }

  .video {
    display: flex;
    border-radius: 1.25rem;
    max-width: 580px;
    overflow: hidden;
    z-index: 0;

    @media (max-width: ${breakpoints.screenMD}) {
      width: 70%;
    }

    @media (max-width: ${breakpoints.screenSM}) {
      width: 100%;
    }
  }
`
